module.exports = __webpack_public_path__ + "static/media/Sentry_char1.f2f64040.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Characters/Sentry_char1.jpg
// module id = 199
// module chunks = 0